<!--
   Created by qing on 2020/12/29
   Des:
-->
<template>
  <ConfigContainer
    :isPhone="isPhone"
    :value="current"
    :type="type">
    <template v-if="current.menuList">

      <div class="menu-config-container" v-if="current.showType === TODO_SHOW_TYPE__WIDE">

        <div
          class="menu-item"
          :style="itemStyle"
          v-for="menu in current.menuList"
          :key="menu.menuId"
          @click="onClickMenu(menu)">

          <div
            class="icon menu-icon"
            :style="{backgroundColor: menu.bgColor, width: isPhone ? '40px': '60px', height: isPhone ? '40px' : '60px'}">
            <i
              v-if="!menu.menuIconType || menu.menuIconType === 'SYSTEM'"
              :class="menu.menuIcon"
              :style="{color: menu.bgColor === '#ffffff' ? '#333333' : '#ffffff', fontSize: isPhone ? '20px' : '40px'}"
            ></i>
            <img
              v-else
              class="custom-menu-icon-img"
              :style="iconStyle"
              :src="menu.menuIcon"
              alt="">
          </div>
          <div class="text" :style="textStyle">
            {{menu.menuName}}
          </div>

        </div>
      </div>

      <div v-else class="menu-item-ver-container">
        <div
          class="menu-item-ver"
          v-for="menu in current.menuList"
          :key="menu.menuId"
          @click="onClickMenu(menu)">

          <div
            class="icon-container"
            :style="{backgroundColor: menu.bgColor}">
            <i
              v-if="!menu.menuIconType || menu.menuIconType === 'SYSTEM'"
              class="menu-icon"
              :class="menu.menuIcon"
              :style="{color: menu.bgColor === '#ffffff' ? '#333333' : '#ffffff'}"
            ></i>
            <img
              v-else
              class="custom-menu-icon-img"
              :src="menu.menuIcon"
              alt="">
          </div>
          <div class="text">
            {{menu.menuName}}
          </div>

        </div>
      </div>

      <create-form-apply
        ref="createFormApply"
        :key="selectFormId"
        :need-button="false"
        :app-id="selectAppId"
        :formId="selectFormId">
      </create-form-apply>

    </template>
  </ConfigContainer>
</template>

<script>
  import ConfigContainer from './common/ConfigContainer'
  import {
    FORM_VIEW_TYPE_BOARD_VIEW, FORM_VIEW_TYPE_BOARD_VIEW_V2,
    FORM_VIEW_TYPE_DASHBOARD_VIEW,
    FORM_VIEW_TYPE_DATA_HANDLE,
    FORM_VIEW_TYPE_DATA_VIEW,
    FORM_VIEW_TYPE_GANTT,
    FORM_VIEW_TYPE_MAP_BUBBLE_VIEW,
    FORM_VIEW_TYPE_MAP_PATH_VIEW,
    FORM_VIEW_TYPE_PHOTO
  } from "../../../assets/types/condition";
  import CreateFormApply from "../../component/CreateFormApply";
  import {TODO_SHOW_TYPE__WIDE} from "../type";

  export default {
    props: {
      value: Object,
      type: Number,
      isPhone: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        TODO_SHOW_TYPE__WIDE,
        current: this.value,
        selectFormId: '',
        selectAppId: '',
        allAppList: []
      }
    },
    components: {
      ConfigContainer,
      CreateFormApply
    },
    created() {
      this.aEle = document.createElement('a')
      this.$store.dispatch('getApps')
        .then(resultObject => {
          this.allAppList = resultObject.allAppList
        }).catch(console.error)
    },
    computed: {
      itemStyle() {
        if (this.isPhone) {
          return {
            width: '80px',
            height: '100px'
          }
        }
      },
      iconStyle() {
        if (this.isPhone) {
          return {
            width: '40px',
            height: '40px'
          }
        }
      },
      textStyle() {

        if (this.isPhone) {
          return {
            fontSize: '12px'
          }
        }
      }
    },
    methods: {
      onClickMenu(menu) {

        switch (menu.menuType) {
          case "app":

            const app = this.allAppList.filter(app => app.appId === menu.menuConfig.appId)[0]
            if (app) {
              this.$store.commit('UPDATE__APP', app)
              this.$router.push({
                name: 'appHome',
                query: {
                  appId: app.appId,
                  appName: app.appName
                }
              })
            } else {
              this.$toast.fail('您暂无权限查看,请联系管理员')
            }
            break
          case "dashboard":
            const loading = this.$toast.loading({message: '加载中...'})
            this.$store.dispatch('actionDashboardPermission', {
              appId: menu.menuConfig.appId,
              dashboardId: menu.menuConfig.dashboardId
            }).then(res => {
              if (res.hasPer) {
                const toast = this.$toast.loading({message: '加载中...'})
                this.$store.dispatch('actionNodeSave', {
                  companyId: this.$store.getters.currentCompanyId,
                  userId: this.$store.getters.userId,
                  appId: menu.menuConfig.appId,
                  dashboardId: menu.menuConfig.dashboardId,
                  token: this.$store.state.token,
                  env: this.$store.getters.env
                })
                  .then(res => {
                    let dashUrl = ''
                    if (process.env.NODE_ENV === 'production') {
                      dashUrl = `${location.origin}${this.$DS_BASE_PATH}/#/dashboard?key=${res.nodeKey}`
                    } else {
                      dashUrl = `https://node.dev.161.54188.online/miniappds/#/dashboard?key=${res.nodeKey}`
                    }
                    // 存store数据
                    sessionStorage.setItem('store', JSON.stringify(this.$store.state))
                    // location.replace(dashUrl)
                    if (this.aEle) {
                      this.aEle.href = dashUrl
                      this.aEle.target = '_self'
                      this.aEle.click()
                    }
                  })
                  .catch(console.error)
                  .finally(() => {
                    toast.clear()
                  })
              } else {
                this.$toast.fail('您暂无权限查看,请联系管理员')
              }
            }).catch(console.error)
              .finally(() => {
                loading.clear()
              })
            break
          case "formApply":
            this.selectFormId = menu.menuConfig.formId
            this.selectAppId = menu.menuConfig.appId
            this.$store.dispatch('actionFormApplyPermission', {
              appId: menu.menuConfig.appId,
              formId: menu.menuConfig.formId
            }).then(res => {
              if (res.hasPer) {
                setTimeout(() => {
                  if (this.$refs.createFormApply) {
                    this.$refs.createFormApply.onClickCreate()
                  }
                }, 300)
              } else {
                this.$toast.fail('您暂无权限发起该表单,请联系管理员')
              }
            }).catch(console.error)
            break
          case "view":
            const toast = this.$toast.loading({message: '加载中...'})
            if (menu.menuConfig.viewId === FORM_VIEW_TYPE_DATA_HANDLE) {
              this.$store.dispatch('actionFormDataPermission', {
                appId: menu.menuConfig.appId,
                formId: menu.menuConfig.formId
              }).then(res => {
                if (res.hasPer) {

                  const toast = this.$toast.loading({message: '加载中...'})
                  this.$store.dispatch('reqNodeSave', {
                    companyId: this.$store.getters.currentCompanyId,
                    userId: this.$store.getters.userId,
                    appId: menu.menuConfig.appId,
                    formId: menu.menuConfig.formId,
                    token: this.$store.state.token,
                    userInfo: this.$store.getters.userInfo
                  })
                    .then(res => {
                      this.$router.push({
                        name: 'formData',
                        query: {
                          key: res.nodeKey
                        }
                      })
                    })
                    .catch(err => {
                      console.error(err)
                    })
                    .finally(() => {
                      toast.clear()
                    })
                } else {
                  this.$toast.fail('您暂无权限查看,请联系管理员')
                }
              }).catch(console.error)
                .finally(() => {
                  toast.clear()
                })
            } else {
              this.$store.dispatch('actionFormViewPermission', {
                appId: menu.menuConfig.appId,
                formId: menu.menuConfig.formId,
                viewId: menu.menuConfig.viewId
              }).then(res => {
                if (res.hasPer) {
                  console.log('menu.menuConfig.viewType', menu.menuConfig.viewType);
                  if ([FORM_VIEW_TYPE_BOARD_VIEW_V2,FORM_VIEW_TYPE_DASHBOARD_VIEW,FORM_VIEW_TYPE_GANTT].includes(menu.menuConfig.viewType)){
                    this.$toast.fail('移动端暂不支持该视图查看，请在PC端查看')
                    return
                  }

                  const toast = this.$toast.loading({message: '加载中...'})
                  this.$store.dispatch('reqNodeSave', {
                    companyId: this.$store.getters.currentCompanyId,
                    userId: this.$store.getters.userId,
                    appId: menu.menuConfig.appId,
                    formId: menu.menuConfig.formId,
                    viewId: menu.menuConfig.viewId,
                    token: this.$store.state.token,
                    userInfo: this.$store.getters.userInfo
                  })
                    .then(res => {
                      this.$router.push({
                        name: 'formData',
                        query: {
                          key: res.nodeKey
                        }
                      })
                    })
                    .catch(err => {
                      console.error(err)
                    })
                    .finally(() => {
                      toast.clear()
                    })

                } else {
                  this.$toast.fail('您暂无权限查看,请联系管理员')
                }
              }).catch(console.error)
                .finally(() => {
                  toast.clear()
                })
            }
            break
          default:
            break
        }
      },
      applySuccess(val) {
        this.$toast.success('提交成功')
      }
    }
  }
</script>

<style lang="less">

  .menu-config-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    padding: 8px;

    .menu-item {
      position: relative;
      float: left;
      left: 0;
      /*margin: 8px;*/
      padding: 0 8px;
      text-align: center;
      width: 194px;
      height: 144px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border: 1px solid transparent;
      cursor: pointer;


      .icon {
        width: 60px;
        height: 60px;
        border-radius: 10px;
        border: 1px solid #e6e6e6;
        box-shadow: 0 8px 10px 0 rgba(68, 137, 255, 0.14);
        transition: all 0.3s;

        i {
          font-size: 40px;
          color: #ffffff;
        }
      }

      .menu-icon {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .custom-menu-icon-img {
        width: 60px;
        height: 60px;
        border-radius: 10px;
        background-color: #ffffff;
        object-fit: cover;
      }

      .text {
        margin-top: 12px;
        line-height: 22px;
        font-size: 16px;
        color: #333333;
        width: 100%;
        display: -webkit-box;
        text-align: center;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        white-space: normal;
        word-break: break-word;
      }

      &:hover {

        .icon {
          transform: translateY(-10px);
          box-shadow: 0 10px 14px 0 rgba(68, 137, 255, 0.14);

        }
      }
    }
  }


  .menu-item-ver-container {
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 6px;
    padding: 8px 16px 16px;

    .menu-item-ver {
      width: 100%;
      height: 40px;
      margin: 0 0 4px;
      padding: 0 12px;
      position: relative;
      align-items: center;
      cursor: pointer;
      display: flex;

      .icon-container {
        width: 24px;
        height: 24px;
        border-radius: 4px;
        border: 1px solid #e6e6e6;
        display: flex;
        justify-content: center;
        align-items: center;

        .menu-icon {
          font-size: 20px;
          color: #ffffff;
        }
      }

      .custom-menu-icon-img {
        width: 24px;
        height: 24px;
        border-radius: 4px;
        border: 1px solid #e6e6e6;
        background-color: #ffffff;
        object-fit: cover;
      }

      .text {
        margin-left: 12px;
        line-height: 22px;
        font-size: 14px;
        color: #333333;
        width: calc(100% - 40px);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-wrap: break-word;
      }

      &:hover {
        border-radius: 6px;
        background: #f4f6f9;
      }
    }
  }
</style>
